import React from 'react';
import ReactAudioPlayer from 'react-audio-player';

type AudioPlayerProps = {
  src: string;
  allowDownload?: boolean;
};

const AudioPlayer: React.FC<AudioPlayerProps> = ({
  src,
  allowDownload = false,
}) => {
  const controlsList = allowDownload
    ? 'noplaybackrate'
    : 'nodownload noplaybackrate';

  return (
    <div className="w-full text-white relative p-4  rounded-lg pl-4 flex flex-col items-center">
      <ReactAudioPlayer
        src={src}
        className="max-h-10"
        preload="auto"
        controls
        controlsList={controlsList}
        title="Audio Player"
      />
    </div>
  );
};
export default AudioPlayer;
